const mockOptions = (prefix: string, count: number) => Array.from({ length: count }, (_, index) => `${prefix} ${String(index + 1).padStart(3, '0')}`)

export const customerRegistrationOptions = {
  categories: ['- 필수선택 -', '신규', '계약', '신규(계약 보류)'],
  bloodTypes: ['혈액형', 'A', 'B', 'O', 'AB', 'A-', 'B-', 'O-', 'AB-'],
  calendarTypes: ['양력', '음력'],
  visits: {
    // 원본 개발 화면의 선택 목록 밀도(199/90/81/30/30)를 유지한 비식별 정적 Mock입니다.
    visit1: ['- 필수선택 -', ...mockOptions('유입경로', 198)],
    visit2: ['- 미선택 -', ...mockOptions('산부인과', 89)],
    visit3: ['- 미선택 -', ...mockOptions('조리원', 80)],
    visit4: ['- 미선택 -', ...mockOptions('추가경로', 29)],
    visit5: ['- 미선택 -', ...mockOptions('추가경로', 29)],
  },
  // 개발 원본의 기본 선택값과 26개 옵션 수를 맞춘 비식별 정적 Mock입니다.
  offices: ['천안', ...mockOptions('지점', 25)],
}

export const customerRegistrationDefaults = {
  advertisementConsent: true,
  smsConsent: true,
  placeholders: {
    photoManager: '미지정',
    email: '미입력',
    weight: '0.0',
    date: 'YYYY-MM-DD',
    partyLocation: '미입력',
    zipcode: '우편번호',
    address: '기본 주소 및 상세 주소',
  },
} as const
